import {
  LISTING_PRODUCT,
  LISTING_PRODUCT_SUCCESS,
  LISTING_PRODUCT_FAILED,
  ADDING_PRODUCT,
  ADDING_PRODUCT_SUCCESS,
  ADDING_PRODUCT_FAILED,
  DELETING_PRODUCT,
  DELETING_PRODUCT_SUCCESS,
  DELETING_PRODUCT_FAILED,
  UPDATING_PRODUCT,
  UPDATING_PRODUCT_SUCCESS,
  UPDATING_PRODUCT_FAILED,
  INFO_PRODUCT,
  INFO_PRODUCT_SUCCESS,
  INFO_PRODUCT_FAILED,
  RESET_PRODUCT_ADD_STATE,
  RESET_PRODUCT_EDIT_STATE,
  RESET_PRODUCT_INFO_STATE
} from "./actionTypes"
import { LOGOUT_LOGGEDIN_USER } from "../../auth/login/actionTypes";
import RequestHandler from "../../../helpers/RequestHandler"

// Signout user if token invalid
const signOutUser = () => ({
  type: LOGOUT_LOGGEDIN_USER,
});

const AddProductInit = () => ({
  type: ADDING_PRODUCT
})

const AddProductSuccess = (payload) => ({
  type: ADDING_PRODUCT_SUCCESS,
  payload
})

const AddProductFailed = (payload) => ({
  type: ADDING_PRODUCT_FAILED,
  payload
})

export const AddProductAction = (data) => {
  return (dispatch) => {
    dispatch(AddProductInit());
    RequestHandler({
      url: "/content-management/product",
      data,
      method: 'POST',
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(function (response) {
        const { message } = response.data
        dispatch(AddProductSuccess(message));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(AddProductFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

const ListingProductInit = () => ({
  type: LISTING_PRODUCT
})

const ListingProductSuccess = (payload) => ({
  type: LISTING_PRODUCT_SUCCESS,
  payload
})

const ListingProductFailed = (payload) => ({
  type: LISTING_PRODUCT_FAILED,
  payload
})

export const LoadProductAction = (data) => {
  return (dispatch) => {
    dispatch(ListingProductInit());
    let base_url = '/content-management/products?';
    const { filter, sort_by, sort_order, per_page_items, current_page, is_active } = data;
    if (filter) {
      base_url += `filter=${filter}&`;
    }
    if (sort_by) {
      base_url += `sort_by=${sort_by}&`;
    }
    if (sort_order) {
      base_url += `sort_order=${sort_order}&`;
    }
    if (per_page_items) {
      base_url += `per_page_items=${per_page_items}&`;
    }
    if (current_page) {
      base_url += `current_page=${current_page}&`;
    }
    if (is_active !== undefined && is_active !== null && is_active !== "") {
      base_url += `is_active=${is_active}&`;
    }
    RequestHandler.get(base_url)
      .then(function (response) {
        const { message, data } = response.data
        const { items, total } = data
        dispatch(ListingProductSuccess({
          items,
          total,
          message
        }));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(ListingProductFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

const InfoProductInit = () => ({
  type: INFO_PRODUCT
})

const InfoProductSuccess = (payload) => ({
  type: INFO_PRODUCT_SUCCESS,
  payload
})

const InfoProductFailed = (payload) => ({
  type: INFO_PRODUCT_FAILED,
  payload
})

export const LoadProductInfoAction = (_id) => {
  return (dispatch) => {
    dispatch(InfoProductInit());
    let base_url = '/content-management/product/'+ _id;
    RequestHandler.get(base_url)
      .then(function (response) {
        const { data } = response.data
        const { item } = data
        dispatch(InfoProductSuccess(item));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(InfoProductFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

// updating
const UpdateProductInit = () => ({
  type: UPDATING_PRODUCT
})

const UpdateProductSuccess = (payload) => ({
  type: UPDATING_PRODUCT_SUCCESS,
  payload
})

const UpdateProductFailed = (payload) => ({
  type: UPDATING_PRODUCT_FAILED,
  payload
})

export const UpdateProductAction = (id, data) => {
  return (dispatch) => {
    dispatch(UpdateProductInit());
    RequestHandler({
      url: `/content-management/product/${id}`,
      data,
      method: 'PUT',
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(function (response) {
        const { message } = response.data
        dispatch(UpdateProductSuccess(message));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(UpdateProductFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

// delete

const DeleteProductInit = () => ({
  type: DELETING_PRODUCT
})

const DeleteProductSuccess = (payload) => ({
  type: DELETING_PRODUCT_SUCCESS,
  payload
})

const DeleteProductFailed = (payload) => ({
  type: DELETING_PRODUCT_FAILED,
  payload
})

export const DeleteProductAction = (_id) => {
  return (dispatch) => {
    dispatch(DeleteProductInit());
    RequestHandler.delete(`/content-management/product/${_id}`)
      .then(function (response) {
        const { message } = response.data
        dispatch(DeleteProductSuccess(message));
        dispatch(LoadProductAction({}));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(DeleteProductFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}

const ResetProductAdd = () => ({
  type: RESET_PRODUCT_ADD_STATE
});
const ResetProductEdit = () => ({
  type: RESET_PRODUCT_EDIT_STATE
});
const ResetProductInfo = () => ({
  type: RESET_PRODUCT_INFO_STATE
});

export const ResetProductAddStateAction = () => {
  return (dispatch) => {
    dispatch(ResetProductAdd());
  }
}

export const ResetProductEditStateAction = () => {
  return (dispatch) => {
    dispatch(ResetProductEdit());
  }
}

export const ResetProductInfoStateAction = () => {
  return (dispatch) => {
    dispatch(ResetProductInfo());
  }
}

export const UpdateProductStatusAction = (id, status, loadData) => {
  return (dispatch) => {
    dispatch(UpdateProductInit());
    RequestHandler.patch(`/content-management/product/${id}`, { is_active: status })
      .then(function (response) {
        const { message } = response.data
        dispatch(UpdateProductSuccess(message));
        dispatch(LoadProductAction(loadData));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const { response } = error
        const { data } = response || {}
        const ResponseMessage = data && data?.message ? data.message : 'Something went wrong.'
        if (ResponseMessage === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(UpdateProductFailed(typeof ResponseMessage !== 'string' ? JSON.stringify(ResponseMessage): ResponseMessage));
        }
      });
  }
}